"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var propTypes = {
    value: PropTypes.number.isRequired,
    hideFractionDigits: PropTypes.bool,
    isStartingPrice: PropTypes.bool,
    unstyled: PropTypes.bool,
    prefix: PropTypes.string,
    suffix: PropTypes.string
};
function formatPrice(value, showFractionDigits) {
    if (showFractionDigits === void 0) { showFractionDigits = true; }
    if (typeof value !== 'number') {
        value = parseFloat(value);
    }
    if (isNaN(value)) {
        return showFractionDigits ? '-,--' : '-';
    }
    var split = value.toFixed(2).split('.');
    // add thousands separator
    var blocks = [];
    for (var i = split[0].length; i > 0; i = i - 3) {
        blocks.unshift(split[0].substring(Math.max(i - 3, 0), i));
    }
    var prefix = blocks.join('.');
    // calculate result
    return "" + prefix + (showFractionDigits ? ',' + split[1] : '');
}
exports.formatPrice = formatPrice;
/**
 * The `Price` component can be used to show tariff rates.
 */
var Price = /** @class */ (function (_super) {
    __extends(Price, _super);
    function Price() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Price.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, value = _a.value, hideFractionDigits = _a.hideFractionDigits, isStartingPrice = _a.isStartingPrice, unstyled = _a.unstyled, prefix = _a.prefix, suffix = _a.suffix, other = __rest(_a, ["children", "className", "value", "hideFractionDigits", "isStartingPrice", "unstyled", "prefix", "suffix"]);
        var currencySymbol = '€';
        var _prefix = isStartingPrice ? 'ab' : prefix;
        return (React.createElement("span", __assign({ className: classnames(className, {
                ee_price: !unstyled
            }) }, other),
            _prefix && React.createElement("span", { "data-part": "prefix" },
                _prefix,
                " "),
            React.createElement("span", { "data-part": "value" }, formatPrice(value, !hideFractionDigits)),
            React.createElement("span", { "data-part": "currency" },
                " ",
                currencySymbol),
            suffix && React.createElement("span", { "data-part": "suffix" },
                " ",
                suffix)));
    };
    Price.propTypes = propTypes;
    Price.defaultProps = {
        value: undefined,
        hideFractionDigits: false,
        isStartingPrice: false,
        unstyled: false,
        prefix: '',
        suffix: ''
    };
    return Price;
}(react_1.Component));
exports.Price = Price;
exports.default = Price;
//# sourceMappingURL=Price.js.map
